import * as React from 'react';

const Payment = () => {
  return <>Payment</>;
};

export default Payment;
